import { useIntl } from 'react-intl'
import { parse, parseISO, format, getUnixTime } from 'date-fns'

import { de, enGB as en } from 'date-fns/locale'

export default function useDateFns() {
  const intl = useIntl()
  const locales = { de, en }

  function formatDate(date: string, formatStr: string) {
    if (typeof date === 'string') {
      //replace '.' with ' ' for Safari and Firefox compatibility
      if (date.length) {
        date = date.replace(/\./g, ' ')
      }
      return format(new Date(date), formatStr, {
        locale: locales[intl.locale as keyof typeof locales] ?? de,
      })
    }
  }

  function formatDateYear(date: string, formatStr: string) {
    return format(parse(date, formatStr, new Date()), 'yyyy')
  }

  function formatUnixTime(date: string, formatStr: string) {
    return getUnixTime(parse(date, formatStr, new Date()))
  }

  return {
    formatDate,
    formatDateYear,
    formatUnixTime,
  }
}
